export const CURSOR_UPDATE = 'cursorUpdate';
